export const CATEGORY_SLUG_INDEX = 0;
export const SUBCATEGORY_SLUG_INDEX = 1;
